import { Option } from '@/common/types';
import { IEmploymentStatusDtoStatusEnum } from '@/types';

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Terminated = 'TERMINATED',
  LeaveOfAbsence = 'LEAVE_OF_ABSENCE',
  Retired = 'RETIRED',
  Future = 'FUTURE',
  COBRA = 'COBRA',
  Null = 'Null',
}

export const EMPLOYEE_STATUS_OPTIONS: Option[] = [
  {
    key: EmployeeStatus.Null,
    value: 'All',
    title: 'All',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.A,
    value: EmployeeStatus.Active,
    title: 'Active',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.T,
    value: EmployeeStatus.Terminated,
    title: 'Terminated',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.L,
    value: EmployeeStatus.LeaveOfAbsence,
    title: 'Leave of absence',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.R,
    value: EmployeeStatus.Retired,
    title: 'Retired',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.F,
    value: EmployeeStatus.Future,
    title: 'Future',
  },
  {
    key: IEmploymentStatusDtoStatusEnum.C,
    value: EmployeeStatus.COBRA,
    title: 'COBRA',
  },
];

export const UNUSED_EMPLOYMENT_STATUSES: string[] = [
  IEmploymentStatusDtoStatusEnum.L,
  IEmploymentStatusDtoStatusEnum.F,
];

export const ROLLOVER_BLOCK_TEXT =
  'Your plan offers rollover. Refer to your plan documents to see if the rollover applies to you.';
